export default __webpack_public_path__ + "static/media/box.380aac9b.svg";